import React from 'react';
import { PriceString } from '@fourthwall/components';
import * as S from './CostsBreakdownTooltipContent.styled';
export const CostsBreakdownTooltipContent = ({ items }) => (React.createElement(S.Container, null, items.map((item) => (React.createElement(S.Item, { key: item.label },
    React.createElement(S.Label, null, item.label),
    React.createElement(S.Value, null,
        React.createElement(PriceString, { value: item.value })))))));
